<style lang="scss" scoped>
</style>

<template>
	<div>
		<compWrapper :title="$t('global.common.base_information',{defaultValue:'基本信息'})" theme="primary">
			<compFormEdit
				ref="formbase"
				align="center"
				class="margin-top-15"
				:formdata="getBase"
				v-model="formData"
			></compFormEdit>
			<footer class="width-50per" style="padding-left:120px;margin-left:25%;">
				<vButton theme="primary" class="margin-right-15" @click="calculate">{{$t('fbb.fedex.calc_measure',{defaultValue:'开始测算'})}}</vButton>
				<vButton theme="error" class="margin-right-15" @click="reset">{{$t('global.common.btn_reset',{defaultValue:'重置'})}}</vButton>
			</footer>
		</compWrapper>
		<compWrapper :title="$t('fbb.fedex.calc_results',{defaultValue:'测算结果'})" theme="info">
			<div  class="text-right margin-10">
				<vButton theme="warning" @click="handleDownload">{{$t('fbb.fedex.calc_import',{defaultValue:'测算结果导出'})}}</vButton>
			</div>
			<vAlert
				class="margin-15"
				theme="warning"
			>{{$t('fbb.fedex.calc_bigtip',{defaultValue:'特别说明：测算的费用包含部分附加费,如：燃油附加费、地址附加费、超长超重附加费等；FedEx是账单制度，签收包裹后会根据官方实际账单产生额外费用，如：成人签字附加费、地址更改费等，实际费用以账单为准，计费重量是包裹毛重和体积重两者取大者，使用FedEX Ground、FedEX Home Delivery两种服务时，若加收Oversize费用时，若包裹计费重量不足90lb时，按90lb计算'})}}</vAlert>
			
			<div v-for="(data,index) in calcList" :key="index"  class="margin-bottom-10">
				<header class="font-14 clearfix">
					<span class="pull-left margin-left-15 width-20per"><span  class="font-bold ">ERP SKU：</span>{{data.erpSku}}</span>
					<span class="pull-left margin-left-15"><span  class="font-bold ">{{$t('global.common.length',{defaultValue:'长'})}}：</span>{{data.length}} {{data.sizeUnit}}</span>
					<span class="pull-left margin-left-15"><span  class="font-bold ">{{$t('global.common.width',{defaultValue:'宽'})}}：</span>{{data.width}} {{data.sizeUnit}}</span>
					<span class="pull-left margin-left-15"><span  class="font-bold ">{{$t('global.common.height',{defaultValue:'高'})}}：</span>{{data.height}} {{data.sizeUnit}}</span>
					<span class="pull-left margin-left-15"><span  class="font-bold ">{{$t('global.common.perimeter',{defaultValue:'周长'})}}：</span>{{data.girth}} {{data.sizeUnit}}</span>
					<span class="pull-left margin-left-15"><span  class="font-bold ">{{$t('global.common.chargeableweight',{defaultValue:'计费重量'})}}：</span>{{data.weight}} {{data.weightUnit}}</span>
				</header>
				<compCalc :data="data.calculationCarrierItems"></compCalc>
			</div>
		</compWrapper>
		<vLoading size="large" transfer :loading="loading"></vLoading>
	</div>
</template>

<script>
// import { mapState, mapGetters } from 'vuex';
import { HttpSkuCalc,HttpDownloadCalc } from "@/service/fedex";
import compCalc from "./calc";
import mixin from './mixin'
export default {
	mixins: [mixin],
	components: {
		compCalc,
		compWrapper: () => import("@components/templates/wrapper"),
		compFormEdit: () => import("@components/templates/formedit")
	},
	data() {
		return {
			loading: false,
			formData: {
				country: "US",
				orgId:this.$store.state.organization.id,
			},
			calcList: [],
		};
	},
	computed: {
		getBase() {
			return [
				{
					label: this.$t('bi.work.task_org_id',{defaultValue:'组织'}),
					tag: "vSelect",
					key: "orgId",
					options: this.getOrgOpt,
					props:{
                        filterable:true
                    },
				},
				{
					label: this.$tc('global.common.country',1,{defaultValue:'国家'}),
					tag: "vSelect",
					key: "country",
					options:this.getCountryList
				},
				{
					label: this.$t('global.common.deliveryWarehouse',{defaultValue:'发货仓库'}),
					tag: "vSelect",
					key: "warehouseId",
					options:this.getWarehouseOpt,
					props:{
                        filterable:true
					},
					on: {
						'on-change': this.handleWarehouseCode
					}
				},
				{
					label: this.$t('fbb.settlement.receivePostal',{defaultValue:'收货地邮编'}),
					key: "postal",
					formItem:{
						rules: {
							required: true,
							// message: "该信息不能为空,请填写",
							validator(rule, value, callback) {
								if (!value || !/^[0-9]{5,}$/g.test(value)) {
									callback(this.$t('fbb.fedex.receivecode_tip',{defaultValue:'该信息不能为空,且长度不能少于五位'}));
								} else {
									callback();
								}
							},
						},
					}
				},
				{
					label: "ERP SKU",
					tag: "vTextarea",
					key: "skus",
					formItem: {
						tip: '<div class=color-error>'+this.$t('fbb.fedex.erpskucalc_tip',{defaultValue:'最多可填50个，ERP SKU必须在所选组织内,以英文逗号隔开'})+'</div>'
					}
				}
			];
		},
	},
	methods: {
		// 获取warehouseCode
		handleWarehouseCode(value, label, attach = {}) {
			this.formData = {
				...this.formData,
				warehouseCode: attach.code,
			}
		},
		handleDownload() {
			this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/carrierCalculation/skuExport", this.formData, 'download')
		},

		async calculate() {
			const valid = await this.$refs.formbase.validate();
			if (!valid) return;
			this.loading = true;
			const formData={...this.formData};
			formData.skus=`${formData.skus}`.replace(/\t|\n|\s/g,'');
			HttpSkuCalc(formData).then(
				res => {
					this.calcList = res.data || [];
					this.loading = false;
				},
				err => {
					this.loading = false;
					this.$VMessage.error(err.message);
				}
			);
		}
	}
};
</script>
